<!--
 * @Author: your name
 * @Date: 2022-03-12 20:40:07
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-24 14:55:10
 * @Description: file content
-->
<template>
  <div class="bottom">
    <InfoContainer v-if="$store.state.lottery.status">
      <template #title>
        <LotteryTitle lottery-title="中奖者名单" />
      </template>
      <template #content>
        <LotteryList
          :value_alone="false"
          :group_title="group_title"
          :user_infos="userinfo"
        ></LotteryList>
      </template>
    </InfoContainer>
    <InfoContainer>
      <template #title>
        <LotteryTitle lottery-title="活动奖品" />
      </template>
      <template #content>
        <!-- detail 中 返回 的 mixedPrizeList 奖品列表 -->
        <LotteryList :values="prizeNames"></LotteryList>
      </template>
    </InfoContainer>
    <InfoContainer>
      <template #title>
        <LotteryTitle lottery-title="活动时间" />
      </template>
      <template #content>
        <!-- detail 中 返回 的 effectiveEndTime 结束时间
        -->
        <LotteryList :values="times"></LotteryList>
      </template>
    </InfoContainer>
    <InfoContainer>
      <template #title>
        <LotteryTitle lottery-title="活动说明" />
      </template>
      <template #content>
        <!-- detail 中 返回 的 remark 活动说明-->
        <SingleInfo :info="remark"></SingleInfo>
      </template>
    </InfoContainer>
  </div>
</template>

<script>
  import LotteryTitle from "../../components/LotteryTitle";
  import LotteryList from "../../components/LotteryList";
  import InfoContainer from "../../components/InfoContainer";
  import SingleInfo from "../../components/SingleInfo";
  import { getPrizeList, getLuckyRecord } from "@/api/lotteryLucky";

  import { TransformToChinese } from "@/utils/numToChn";
  export default {
    data() {
      return {
        //  抽奖活动 id
        // luckyAwardId: "9ae2573f-ab22-430c-8699-7cbb89850d68",
        // luckyAwardId: "a41a50a8-046b-4f3c-a3ff-1c0f4dd873e0",
        luckyAwardId: this.$route.query.luckyAwardId,
        // "e0c41e49-a09d-49e9-bce6-acd762177f26"
        // http://localhost:8080/luckyAward?luckyAwardId=a41a50a8-046b-4f3c-a3ff-1c0f4dd873e0
        prizes: [],
        prizeNames: [],
        remark: "",
        times: [],
        userinfo: [
          // {
          //   username: "ERNEST",
          //   prize_rank: "一等奖",
          //   avatar: "https://img01.yzcdn.cn/vant/cat.jpeg",
          // },
          // {
          //   username: "ERNEST",
          //   prize_rank: "一等奖",
          //   avatar: "https://img01.yzcdn.cn/vant/cat.jpeg",
          // },
          // {
          //   username: "ERNEST",
          //   prize_rank: "一等奖",
          //   avatar: "https://img01.yzcdn.cn/vant/cat.jpeg",
          // },
        ],
        prizeModalInfo: [],
        winner: 0,
      };
    },
    components: { LotteryTitle, LotteryList, SingleInfo, InfoContainer },
    created() {
      getPrizeList({
        // luckyAwardId: this.luckyAwardId,
        luckyAwardId: this.$route.query.luckyAwardId,
      }).then((res) => {
        if (res.code === 0) {
          let result = res.data;
          this.prizeNames = [];
          // 渲染奖品列表
          for (let prize of result.mixedPrizeList) {
            // MARK:
            let rank = `${TransformToChinese(prize.subscript)}等奖`;
            switch (prize.prizeType) {
              case "THANKS":
                // prize.prizeName = `${TransformToChinese(prize.subscript)}等奖`;
                prize.prizeName = "谢谢参与";
                break;
              case "GOODS":
                // this.prizeNames.push([prize.prizeName, prize.goodsName]);
                this.prizeNames.push([rank, prize.prizeName, prize.id]);
                break;
              case "RED_PACKET":
                // this.prizeNames.push([prize.prizeName, prize.redPacketName]);
                this.prizeNames.push([rank, prize.prizeName, prize.id]);
                break;
              default:
                break;
            }
          }

          this.prizes = result.mixedPrizeList; // 完整奖品列表
          this.remark = result.remark; // 活动说明
          this.effectiveEndTime = result.effectiveEndTime; // 结束时间
          this.lotteryTime = result.lotteryTime; // 开奖时间
          this.times.push(
            ["开奖时间", result.lotteryTime],
            ["结束时间", result.effectiveEndTime]
          );

          // 活动参加状态
          this.$store.commit("lottery/UPDATE_JOIN_STATUS", {
            joinStatus: result.joinStatus,
          });
          this.openedPrizeStatus = result.status; // 开奖状态
          this.$store.commit("lottery/UPDATE_OPENED_STATUS", {
            status: result.status,
          });
          // 进行状态更新 判断
          // 参加了活动 但是 未开奖
          if (
            this.$store.state.lottery.joinStatus === true &&
            this.$store.state.lottery.status === false
          ) {
            // 更新状态 待开奖
            this.$store.commit("lottery/OPTION_WAIT_OPEN_PRIZE", {});
          } else if (this.$store.state.lottery.status === true) {
            // 开奖了
            // this.$store.state.lottery.joinStatus === true &&
            // 如果已经开奖
            if (this.$store.state.lottery.joinStatus === false) {
              // 客户未参加
              // 活动已结束 提示 已结束
              this.$store.commit("lottery/OPTION_LUCKY_END", {});
            }
            // else if (this.$store.state.lottery.joinStatus === true)
            // 参加了活动 并且已开奖
            getLuckyRecord({
              luckyAwardId: this.$route.query.luckyAwardId,
              // luckyAwardId: "9ae2573f-ab22-430c-8699-7cbb89850d68",
            }).then((res) => {
              if (res.code === 0) {
                // 中奖者名单 数组
                let record_result = res.data;
                for (let item of record_result) {
                  switch (item.prizeType) {
                    case "GOODS":
                      // 更新中奖名单
                      this.update_userinfo(item);
                      break;
                    case "RED_PACKET":
                      // 更新中奖名单
                      this.update_userinfo(item);
                      break;
                    default:
                      break;
                  }
                  console.group(
                    "%c Item 中奖记录",
                    "color: #f00; font-size: 20px;"
                  );
                  console.log(item);
                  console.groupEnd();
                  this.winner = this.userinfo.length;
                  //  中奖逻辑处理
                  if (item.customerId === this.$store.state.user.customerId) {
                    this.$store.commit("lottery/UPDATE_PRIZER", {
                      prizer: item,
                    });
                    console.group("%c 中奖了", "color: #f00; font-size: 20px;");
                    console.log(item, "中奖者信息");
                    console.groupEnd();

                    // MARK: 获取一下 rank  和  奖品名字 item.awardName
                    switch (item.prizeType) {
                      case "THANKS":
                        this.$store.commit("lottery/OPTION_THANKS", {});
                        this.$notify({
                          message: "谢谢您的参与，很遗憾您没有中奖!",
                          color: "#006600",
                          background: "#ffffff",
                          duration: 3000,
                        });
                        break;
                      case "GOODS":
                        // 更新提示文字
                        this.$store.commit("lottery/OPEN_PRIZE", {
                          prize: item.awardName,
                        });
                        // 弹出立即获取的 按钮
                        this.$store.commit("lottery/CHANGE_PRIZED", {
                          prized: true,
                        });
                        let prizename = this.prizeNames.find((p) => {
                          return p[2] === item.id;
                        });
                        this.$store.commit(
                          "lottery/UPDATE_PRIZE_MODAL",
                          prizename
                        );
                        break;
                      case "RED_PACKET":
                        // 更新提示文字
                        this.$store.commit("lottery/OPEN_PRIZE", {
                          prize: item.awardNamed,
                        });
                        this.$store.commit("lottery/RED_PACKET_TIPS", {});
                        this.$notify({
                          message: "红包已发放至您的账户中",
                          color: "#006600",
                          background: "#ffffff",
                          duration: 3000,
                        });
                        break;
                      default:
                        break;
                    }
                  }
                }
              }
            });
            // }
          }
        }
      });
    },
    methods: {
      update_userinfo(item) {
        this.userinfo.push({
          username: item.customerName,
          prize_rank: item.awardName,
          avatar: item.headImgUrl,
        });
      },
    },
    computed: {
      group_title() {
        return this.winner + "人中奖";
      },
    },
  };
</script>

<style lang="less" scoped>
  .bottom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 54px 54px 0 0;
    background: snow;
  }
</style>
